<script setup lang="ts">
const { refusalReasonCode } = defineProps<{
  refusalReasonCode: string;
}>();

const { t, te } = useI18n();

const title = computed(() => {
  const baseTitle = t("myAccount.paymentResult.Failure.title");
  const reasonKey = `payment.refusalReasonCode.${refusalReasonCode}`;
  const reasonText = te(reasonKey) // check if translation exists for this reason key, default to "unkown error"
    ? t(reasonKey)
    : t("payment.refusalReasonCode.unknown");

  return baseTitle + reasonText;
});
</script>

<template>
  <BaseInfoMessage
    variant="danger"
    :title="title"
    data-cy="checkout-payment-failed-block"
  >
    <span
      v-if="$te(`payment.refusalReasonDescription.${refusalReasonCode}`)"
      class="pr-1"
    >
      {{
        `${$t(`payment.refusalReasonDescription.${refusalReasonCode}`)} [${refusalReasonCode}]`
      }}
    </span>

    <I18nT
      scope="global"
      tag="span"
      keypath="myAccount.paymentResult.support"
    >
      <template #link>
        <BaseCustomerSupportLink
          class="checkout-payment-failed-block__support-link"
        >
          {{ $t("myAccount.paymentResult.supportLink") }}
        </BaseCustomerSupportLink>
      </template>
    </I18nT>
  </BaseInfoMessage>
</template>
